import React, { useState } from 'react';
import '../CSS/Global.css';
import AddTimeLog from './AddTimeLog';

const ActivityProjectDetail = ({ isOpen, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const activityData = {
        projectName: 'Website Development',
        customerName: 'XYZ Corp',
        billingMethod: 'Hourly',
        projectCost: '$1500',
        loggedHours: '12:45',
        task: 'Design Homepage',
        user: 'Alice Doe',
        description: 'Working on the homepage layout and responsiveness.',
    };

    return (
        <>
            <div className={`activity-detail-drawer ${isOpen ? 'open' : ''}`}>
                <div className="activity-detail-drawer-content">
                    <button className="close-btn" onClick={onClose}>
                        &times;
                    </button>
                    <h2 className="activity-detail-drawer-title">Activity Project Details</h2>

                    <div className="activity-detail-hero">
                        <div className="info-card">
                            <div className="header-section">
                                <h3 className="title-text">Project Information</h3>
                            </div>
                            <div className="content-section">
                                <div className="data-group">
                                    <p className="label-text">Project Name</p>
                                    <p className="value-text">{activityData.projectName}</p>
                                </div>
                                <div className="data-group">
                                    <p className="label-text">Customer Name</p>
                                    <p className="value-text">{activityData.customerName}</p>
                                </div>
                                <div className="data-group">
                                    <p className="label-text">Billing Method</p>
                                    <p className="value-text">{activityData.billingMethod}</p>
                                </div>
                                <button className="add-timelog-btn" onClick={() => setIsModalOpen(true)}>Add Time Log</button>
                            </div>
                        </div>
                    </div>
                    <hr />

                    <div className="activity-detail-drawer-section">
                        <h3>Project Summary</h3>
                        <p><strong>Project Cost:</strong> {activityData.projectCost}</p>
                        <p><strong>Logged Hours:</strong> {activityData.loggedHours}</p>
                    </div>
                    <hr />

                    <div className="activity-detail-drawer-section">
                        <h3>Task Information</h3>
                        <ul>
                            <li>{activityData.task}</li>
                            <li>{activityData.task}</li>
                        </ul>
                    </div>
                    <hr />

                    <div className="activity-detail-drawer-section">
                        <h3>User Information</h3>
                        <ul>
                            <li>{activityData.user}</li>
                            <li>{activityData.user}</li>
                            <li>{activityData.user}</li>
                        </ul>
                    </div>
                    <hr />

                    <div className="activity-detail-drawer-section">
                        <h3>Description</h3>
                        <p>{activityData.description}</p>
                    </div>
                </div>
            </div>


            <AddTimeLog isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default ActivityProjectDetail;
